import * as gzDeviceStatus from './device-status.service';

export default angular.module('gazelle.components.deviceStatus', [
  'gazelle.components.l10n'
])
  .service(gzDeviceStatus.name, gzDeviceStatus.default)
  .name;

